// ----------------------------------------------- main
import { useEffect, useState } from "react";

// ----------------------------------------------- local
import WebInfoContext, { HeaderItem } from "./WebInfoContext.ts";
import useAxios from "services/useAxios.tsx";
import { CategoryInterface } from "../../interfaces/Category.ts";
import { useLocation } from "react-router-dom";

const CONTENTS = [
  {
    title: "",
    icon: "",
    link: "",
  },
];

export default function WebInfo({ children }: { children: JSX.Element }) {
  const { execute: getMainCategory } = useAxios("hashtag/get_main_hashtag");
  const { execute: getMainOption } = useAxios("/api3/option_list");

  const [options, setOptions] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [categorys, setCategorys] = useState<CategoryInterface[]>([]);

  // const [subCategorys,setSubCategorys] = useState<CategoryInterface[]>([]);
  // ---------------------------> Start getCategoryMain
  const location = useLocation();

  const getMainCategorys = () => {
    getMainCategory().then(async ({ data }) => {
      let temp = await Promise.all(
        data.filter((obj: any) => +obj.hashtag.hashtag_status === 0)
      );
      setCategorys(temp);
    });
  };
  // ---------------------------> End getCategoryMain

  // ---------------------------> Start-Options
  const getMainOptions = () => {
    getMainOption().then((res) => {
      setOptions(res.result);
    });
  };
  // ---------------------------> End-Options

  // ---------------------------> Start-Search
  const getPathSearch = () => {
    const urlParams = new URLSearchParams(location.search);
    let keyword = urlParams.get("keyword");
    setSearchQuery(keyword);
  };
  // ---------------------------> End-Search

  useEffect(() => {
    getMainCategorys();
    getMainOptions();
  }, []);

  useEffect(() => {
    if (location.pathname.includes("search")) {
      getPathSearch();
    } else {
      setSearchQuery("");
    }
  }, [location]);

  return (
    <>
      <WebInfoContext.Provider
        value={{
          webInfo: {
            logo: "",
            title: "یانگ گالری",
            description: "سایت یانگ گالری",
            aboutUs: `یانگ گالری فروشگاه تخصصی به روز ترین و گنگ ترین اکسسوری بدلیجات و ساعت و... برای تمام سنین و سلیقه ها با محصولات با کیفیت و تماما وارداتی در خدمت شما عزیزان هستیم از سال ۱۳۹۹ هم به صورت حضوری هم آنلاین با هدف خاص و شیک تر شدن استایل شما`,
          },
          categorys,
          options,
          contents: CONTENTS,
          searchQuery,
          setSearchQuery,
        }}
      >
        {children}
      </WebInfoContext.Provider>
    </>
  );
}
